"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._PreviewReferences = void 0;
exports._PreviewReferences = {
    confirmPreview: {
        dataTag: 'action',
        required: false,
        keepRefTag: true,
        dontRemoveFromDom: true,
        uid: 'confirmPreview',
        description: 'Confirms the preview.',
    },
    cancelPreview: {
        dataTag: 'action',
        required: false,
        keepRefTag: true,
        dontRemoveFromDom: true,
        uid: 'cancelPreview',
        description: 'Closes the preview and returns to previous step.',
    },
};
